module.exports = __webpack_public_path__ + "img/杨蝶拍摄.a455aaf8.jpg";